const questionTypes = {
  BINARY_CHOICE: 'BINARY_CHOICE',
  NON_BINARY_SINGLE_CHOICE: 'NON_BINARY_SINGLE_CHOICE',
  NON_BINARY_MULTI_CHOICE: 'NON_BINARY_MULTI_CHOICE',
};

export { questionTypes };
